<template>
  <div class="search">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          v-model="logstoreNameSearchKey"
          :placeholder="$t('alarms.logService.pleaseEnterLogStoreName')"
        />
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['monitor:logManagementMonitor:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import TableLogManagement from "../log_management/TableLogManagement";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
var tableLogManagement = TableLogManagement;
export default {
  name: "LogManagementSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      stateSearchKey: [],
      logstoreNameSearchKey: "",
      logstoreNameSearchName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("logstoreNameSearchName", this.logstoreNameSearchKey);
      tableLogManagement.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.search {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/log_management/LogManagementSearch.vue